import {useTranslation} from 'react-i18next';
import {STATIC_IMAGE} from '../../../config/config';
import * as css from './EmptyAttendance.css';

function EmptyAttendance() {
    const {t} = useTranslation('attendance');

    return (
        <css.emptyContainer>
            <css.emptyImage 
                src={`${STATIC_IMAGE}/app/attendance/attendanceEmpty.png`}
                alt={t('noAttendance')}
            />
            <css.emptyText>
                {t('noAttendanceMessage')}
            </css.emptyText>
        </css.emptyContainer>
    );
}

export default EmptyAttendance;
